 
import PropTypes from 'prop-types';
import Flex from '@/components/common/Flex';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const TableRow = ({ data }: Record<string, any>) => {
  const { label, color, percentage, count } = data;
  return (
    <tr>
      <td className="py-3">
        <Flex alignItems="center">
          <FontAwesomeIcon icon="circle" className={`text-${color} fs--2`} />
          <h6 className="text-600 mb-0 ms-2">{label}</h6>
        </Flex>
      </td>
      <td className="py-3">
        <Flex alignItems="center">
          <h6 className={`fw-bold mb-0 text-${color}`}>{percentage}%</h6>
        </Flex>
      </td>
      <td className="py-3">
        <Flex alignItems="center" justifyContent="end">
          <h6 className="text-700 fw-bold mb-0 ">{count}</h6>
        </Flex>
      </td>
    </tr>
  );
};

TableRow.propTypes = {
  data: PropTypes.shape({
    label: PropTypes.string,
    color: PropTypes.string,
    percentage: PropTypes.number,
    count: PropTypes.number
  }).isRequired
};

export default TableRow;
